// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"4649f653","232":"d540df99","237":"ed33516d","357":"30a78755","526":"18cd899e","787":"28dea5ca","872":"9c2385b8"}[chunkId] + ".chunk.js";
};